export type InsightCategory =
  | 'structure'
  | 'data-quality'
  | 'opportunity'
  | 'risk'
  | 'next-action'
  | 'pattern';

export type InsightPriority = 'critical' | 'high' | 'medium' | 'low' | 'info';

export interface IInsight {
  id: string;
  category: InsightCategory;
  priority: InsightPriority;

  title: string;
  description: string;
  icon?: string;

  relevanceScore: number;
  affectedNodeIds: string[];

  actionLabel?: string;
  action?: () => void | Promise<void>;

  isDismissible: boolean;
  dismissedAt?: Date;
  computedAt: Date;
}

export const createInsight = (
  partial: Omit<IInsight, 'computedAt' | 'relevanceScore'> & {
    relevanceScore?: number;
  }
): IInsight => ({
  ...partial,
  relevanceScore: partial.relevanceScore ?? 0,
  computedAt: new Date(),
});
